module.exports = __webpack_public_path__ + "9cf6317ffa0e9c7f97c5c355eb5438d3.png";